import { useMemo } from "react";
import DynamicForm from "@view/common/DynamicForm";
import { DynamicFormSchema } from "@view/common/DynamicForm/DynamicFormContracts";
import styles from "./OtpSlide.module.css";
import { ISignInProcessInitWithUrlDto } from "@presentation/controllersModels/ISignInProcessInitWithUrlDto";
import DynamicTextField from "@view/common/Components/DynamicFields/DynamicTextField";
import LoginOtpSumbit from "./LoginOtpSubmit";
import min4LengthRegex from "@presentation/regexes/min4LengthRegex";

export interface ILoginWithEmailOtpFormValue {
  otpCode: string;
}

export interface ILoginWithEmailOtpSlideProps {
  onSuccess: (sessionInfo: ISignInProcessInitWithUrlDto) => void;
  callGenerateOtpApi: (email: string, isResend?: boolean) => void;
  callLoginApi: (password: string) => void;
  className?: string;
  email: string;
  loading: boolean;
  loadingOtp: boolean;
  reset: boolean;
}

const OtpSlide = (props: ILoginWithEmailOtpSlideProps) => {

  const onSubmit = (value: ILoginWithEmailOtpFormValue, anyError: boolean) => {
    if (anyError) return;
    props.callLoginApi(value.otpCode);
  };

  const formSchema = useMemo(() => {
    const schema: DynamicFormSchema<ILoginWithEmailOtpFormValue> = {
      columns: 12,
      submitLabel: "Iniciar sesión",
      submitFieldColumns: 12,
      initValues: {
        otpCode: "",
      },
      fields: [
        {
          columns: 12,
          label: "Código",
          name: "otpCode",
          type: "string",
          attributes: {
            disableArrows: true,
            type: "number",
            regexes: [{ expression: min4LengthRegex }],
            maxLength: 4,
            required: true,
          }
        },
      ]
    };
    return schema;
  }, []);

  const _className = useMemo(() => (
    [
      styles.root,
      props.className,
    ].filter(x => x !== undefined).join(" ")
  ), [props.className]);

  const onResendOtp = () => {
    props.callGenerateOtpApi(props.email, true);
  };

  return (
    <div className={_className}>
      <DynamicForm
        loading={props.loading}
        disabled={props.loading}
        onSubmit={onSubmit as any}
        className={styles.form}
        schema={formSchema}
        context={{
          fieldsMap: {
            "string": DynamicTextField,
          },
          SubmitField: x => <LoginOtpSumbit loadingOtp={props.loadingOtp} loading={props.loading} onResend={onResendOtp} {...x} label="Ingresar" />,
          requiredIndicator: true
        }}
        reset={props.reset}
      />
    </div>
  );

};

export default OtpSlide;
